var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"booking-list"},_vm._l((_vm.listData),function(item){return _c('BookingCard',{key:item.index,attrs:{"annotation":_vm.annotation,"activeTab":_vm.activeTab,"content":item,"bookingStatus":_vm.bookingStatus},on:{"deleteBooking":_vm._deleteHandler}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }